import type { Stripe, StripeElements } from "@stripe/stripe-js";
import type { TFunc } from "../i18n";
import { formatBillingError } from "./billingErrors";

export async function confirmStripeCheckout(input: {
  stripe: Stripe;
  elements: StripeElements;
  returnUrl: string;
  onPaid: () => void;
  onError: (message: string) => void;
  t: TFunc;
}): Promise<void> {
  try {
    const { error, paymentIntent } = await input.stripe.confirmPayment({
      elements: input.elements,
      confirmParams: { return_url: input.returnUrl },
      redirect: "if_required"
    });
    if (error) {
      input.onError(formatBillingError(error, input.t, input.t("billing.failed")));
      return;
    }
    if (paymentIntent && (paymentIntent.status === "succeeded" || paymentIntent.status === "processing")) {
      input.onPaid();
      return;
    }
    input.onError(input.t("billing.failed"));
  } catch (error) {
    input.onError(formatBillingError(error, input.t, input.t("billing.failed")));
  }
}
